// @flow

import React from 'react'
import { Field } from 'redux-form'
import { FormInput, Select, InputZipByCountry } from 'src/common/components'
import { required, validateLength } from 'src/helpers/formValidation'
import { normalizeText } from 'src/helpers/formNormalizers'
import * as countriesConfig from 'src/config/countries'
import { COUNTRY_CODES } from 'src/common/constants'

import type { AddressBlockPropsType } from './AddressBlockTypes'

const AddressBlock = ({
  prefix,
  title,
  selectData,
  isAddressDisabled = false,
  isSelectDisabled = false,
  validateZip = true,
  withCountyRequired = false,
  isCountyDisabled = false,
  requiredField = true,
  change,
  country,
  availableCountries = countriesConfig.countries,
  isCountryDisabled = false,
  errorMessage,
}: AddressBlockPropsType) => {
  return (
    <div>
      <h4>{title}</h4>
      {errorMessage && <p className="form-error">{errorMessage}</p>}
      {Array.isArray(selectData) && (
        <div className="form-row">
          <div className="form-group">
            <label>Address</label>
            <div>
              <Field
                name={`${prefix}address_id`}
                id={`${prefix}address_id`}
                component={Select}
                placeholder="Add New Address"
                selectData={[...selectData]}
                disabled={isSelectDisabled}
              />
            </div>
          </div>
        </div>
      )}
      <div className="form-row">
        <div className="form-group">
          <label className={requiredField ? 'required' : ''}>Street Address</label>
          <div>
            <Field
              name={`${prefix}address_1`}
              id={`${prefix}address_1`}
              component={FormInput}
              placeholder="Street building"
              disabled={isAddressDisabled}
              normalize={normalizeText}
              validate={requiredField ? [required, validateLength('address')] : [validateLength('address')]}
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <div>
            <Field
              name={`${prefix}address_2`}
              id={`${prefix}address_2`}
              component={FormInput}
              placeholder={
                isAddressDisabled ? null : 'Apt Suite etc (optional)'
              }
              disabled={isAddressDisabled}
              normalize={normalizeText}
              validate={[validateLength('address')]}
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className={requiredField ? 'required' : ''}>City</label>
          <div>
            <Field
              name={`${prefix}city`}
              id={`${prefix}city`}
              component={FormInput}
              disabled={isAddressDisabled}
              normalize={normalizeText}
              validate={requiredField ? [required, validateLength('city')] : [validateLength('city')]}
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className={(!isCountyDisabled && withCountyRequired) ? 'required' : ''}>County, NOT Country</label>
          <div>
            <Field
              name={`${prefix}county`}
              id={`${prefix}county`}
              component={FormInput}
              normalize={normalizeText}
              validate={withCountyRequired ? [required, validateLength('county')] : [validateLength('county')]}
              disabled={isAddressDisabled && isCountyDisabled}
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <div className="form-row without-margin">
            <div className="form-group">
              <label className={requiredField ? 'required' : ''}>
                { country === COUNTRY_CODES.CA ? 'Province' : 'State' }
              </label>
              <div>
                <Field
                  id={`${prefix}state`}
                  name={`${prefix}state`}
                  component={Select}
                  selectData={country === COUNTRY_CODES.CA ? countriesConfig.provinces : countriesConfig.states}
                  validate={requiredField ? [required] : []}
                  disabled={isAddressDisabled}
                />
              </div>
            </div>
            <div className="form-group">
              <label className={requiredField ? 'required' : ''}>Zip Code</label>
              <div>
                <InputZipByCountry
                  name={`${prefix}zip`}
                  id={`${prefix}zip`}
                  country={country}
                  validateZip={validateZip}
                  disabled={isAddressDisabled}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Country</label>
          <div>
            <Field
              id={`${prefix}country`}
              name={`${prefix}country`}
              component={Select} selectData={availableCountries}
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddressBlock
